import { extendTheme } from "@chakra-ui/react";

export const customTheme = extendTheme({
  colors: {
    headerbg: "#93C0A4",
    filtersbg: "#B3D1BE",
    cardHeader: "#93C0A4",
    sidebarbg: "#F3F7F5",
    sidebarnotebg: "#CFF2D2",
    cardbg: "#F3F7F5",
    postitbg: "red",
    tag: "#69776B",
    inputHighlight: "#D8B4A0",
    resetDelBg: "#FF707E",
    resetHover: "#FFADB6",
  },
});
